import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope2Form = ({ disabled }) => (
  <ScopeEmissionForm
    scopeKey="scope2"
    label="Scope 2 Emissions"
    disabled={disabled}
  />
);

export default Scope2Form;
